import { ChangeEventHandler, useEffect } from "react";
import { Select } from "theme-ui";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { extractBaseLang } from "src/utils";
import { getLocation } from "src/redux/slices";

const LANGS = [
  { label: "English", value: "en" },
  { label: "Español", value: "es" },
];

export const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const currentLanguage = extractBaseLang(i18n.language);
  const changeLanguage: ChangeEventHandler<HTMLSelectElement> = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  useEffect(() => {
    if (currentLanguage !== "es") {
      dispatch(getLocation());
    }
  }, [currentLanguage, dispatch]);

  return (
    <Select
      defaultValue={currentLanguage}
      onChange={changeLanguage}
      sx={{ borderRadius: "5px 5px 0px 0px", px: 3, width: 4, height: "40px" }}
    >
      {LANGS.map(({ value, label }) => (
        <option value={value} key={value}>
          {label}
        </option>
      ))}
    </Select>
  );
};
